var base = require('settings/preferences/screenshots');
Vue.component('spark-preferences-screenshots', {
    mixins: [base]
});
